export const type = 'guardarUsuario'

const guardarUsuario = objeto => {
    return {
        type,
        payload: objeto
    }
}

export default guardarUsuario